import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import undrawProfile from "../img/undraw_profile.svg";
import cameraIcon from "../img/camera-icon.png";
import profile1 from "../img/profile-1.png";
import { staticMessages } from "../shared/const.staticMessages";
import ProfileView from "../components/ProfileView";
import ProfileActivity from "../components/ProfileActivity";
import {
  getuserInfo,
  getFollowersList,
  getFollowingsList,
  getFollowersFollowingsCount,
  getImagesFromPosts,
} from "../store/actions/userActions";
import {
  getCountryList,
  getLanguageList,
  getStateList,
} from "../store/actions/utilActions";
import {
  concatenateAndTruncate,
  truncateText,
} from "../../utils/application-helper";
import { AppContext } from "../contexts/AppContext";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import axiosHttp from "../config/axios.interceptor";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { AuthContext } from "../contexts/AuthContext";
import { NavLink } from "react-router-dom";
import { errorResponseMessage } from "../shared/const.prop";
import VideoComponent from "../components/VideoComponent";

const MyActivity = () => {
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const { isLoggedIn, userData } = useSelector((state) => state.user);
  const { stateList, countryList } = useSelector((state) => state.utilData);
  const [profile, activity] = staticMessages.mySpace.tabs;
  const [activeTab, setActiveTab] = useState(profile);
  const [testimonials, setTestimonials] = useState([]);
  const tabSwitchHandler = (event, tab) => {
    event.preventDefault();
    setActiveTab(tab);
  };

  // Some computed data
  const [userInfo, setUserInfo] = useState({
    stateName: "",
    countryName: "",
  });

  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(getuserInfo());
    } else if (isLoggedIn && Object.keys(userData).length > 0) {
      dispatch(getCountryList());
      dispatch(getStateList(userData?.address?.countryId || ""));
      dispatch(getFollowersFollowingsCount());
      dispatch(getFollowersList());
      dispatch(getFollowingsList());
      dispatch(getLanguageList());
      dispatch(getActiveNotificationCount());
      dispatch(getActiveChatNotificationCount());
      fetchTestimonials();
    }
  }, [isLoggedIn]);

  const fetchTestimonials = () => {
    axiosHttp
      .get(`testimonials`)
      .then((apiResponse) => {
        if (apiResponse.status === 200) {
          setTestimonials(apiResponse?.data?.data ?? []);
        } else {
          console.log(error);
        }
      })
      .catch((error) => {
        if (error.response.status === 429) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
          authContext.logout();
        }
        if (error.response.status === 400) {
          appContext.updateNotificationState({
            show: true,
            message: errorResponseMessage(error),
            type: "error",
          });
        }
        if (error.response?.status >= 500) {
          appContext.updateNotificationState({
            show: true,
            message: "Something went wrong, please try again later.",
            type: "error",
          });
        }
      });
  };

  useEffect(() => {
    if (
      countryList &&
      countryList?.length > 0 &&
      userData?.address?.countryName
    ) {
      const userCountryInfo = countryList.filter((item) => {
        return item.id === userData?.address?.countryId;
      });
      if (userCountryInfo?.length > 0) {
        setUserInfo({
          ...userInfo,
          countryName: userCountryInfo[0]?.name || "",
        });
      }
    }
  }, [countryList]);

  useEffect(() => {
    if (stateList && stateList?.length > 0 && userData?.address?.stateName) {
      const userStateInfo = stateList.filter((item) => {
        return item.id === userData?.address?.stateId;
      });
      if (userStateInfo?.length > 0) {
        setUserInfo({
          ...userInfo,
          stateName: userStateInfo[0]?.name || "",
        });
      }
    }
  }, [stateList]);

  const renderMedia = () => {
    if (userData?.bannerUrl === null) {
      return (
        <img
          src={profile1}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    }
    const fileExtension =
      userData?.bannerUrl &&
      userData?.bannerUrl.split(".").pop()?.toLowerCase();

    if (
      fileExtension === "png" ||
      fileExtension === "jpeg" ||
      fileExtension === "jpg" ||
      fileExtension === "gif"
    ) {
      return (
        <img
          src={userData.bannerUrl}
          alt="User Banner"
          className="img-fluid postion-absolute banner-img"
        />
      );
    } else if (!fileExtension) {
      return (
        <img
          src={userData?.bannerUrl}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    } else {
      return <VideoComponent userData={userData} />;
    }
  };

  return (
    <>
      <div className="card  card-one-1">
        {renderMedia()}
        <img
          src={cameraIcon}
          className="img-fluid camera-icon cursor-pointer"
          data-toggle="modal"
          data-target="#photo"
          onClick={() =>
            appContext.updateModalType(
              "addBackgroundImage",
              userData?.bannerUrl
                ? "Update background photo"
                : "Add background photo"
            )
          }
        />
        {/* <span className="active-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <circle cx="7" cy="7" r="7" fill="#4FBA3F" />
          </svg>
        </span> */}

        <div className="card-body">
          <div className="d-flex justify-content-between">
            <img
              className="img-profile rounded-circle profile-img ml-1"
              src={userData?.picUrl || undrawProfile}
              onClick={() =>
                appContext.updateModalType(
                  "addProfilePhoto",
                  userData?.picUrl
                    ? "Update Profile photo"
                    : "Add Profile photo"
                )
              }
            />
            {/* <span
              className="pen-btn cursor-pointer"
              data-toggle="modal"
              data-target="#about"
              onClick={() =>
                appContext.updateModalType("addBasicInfo", "Basic Information")
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.4303 3.0447C13.472 3.0772 14.8661 4.16054 14.8661 4.16054C15.3728 4.4622 15.7686 5.00137 15.9186 5.6397C16.0678 6.27137 15.9595 6.92303 15.612 7.47387C15.6097 7.47754 15.6074 7.48117 15.5993 7.49197L15.593 7.50031C15.5366 7.57465 15.2914 7.8847 14.0539 9.43519C14.0424 9.45551 14.0294 9.47454 14.0151 9.49303C13.9943 9.52029 13.9716 9.54535 13.9473 9.56817C13.8629 9.67445 13.7738 9.78612 13.68 9.90353L13.4901 10.1414C13.0982 10.6322 12.6333 11.2142 12.0818 11.9046L11.7988 12.2588C10.734 13.5914 9.37044 15.2977 7.62364 17.483C7.24114 17.9597 6.66781 18.2372 6.05198 18.2447L3.01948 18.283H3.01114C2.72198 18.283 2.47031 18.0847 2.40281 17.8022L1.72031 14.9097C1.57948 14.3105 1.71948 13.6922 2.10364 13.2122L9.95364 3.39387C9.95698 3.39054 9.95948 3.38637 9.96281 3.38304C10.8236 2.35387 12.3803 2.2022 13.4303 3.0447ZM9.07842 6.48917L3.07948 13.993C2.93698 14.1714 2.88448 14.4014 2.93698 14.6222L3.50448 17.0264L6.03698 16.9947C6.27781 16.9922 6.50031 16.8847 6.64781 16.7014C7.40738 15.751 8.36202 14.5566 9.34352 13.3283L9.69077 12.8938L10.0386 12.4585C10.9591 11.3066 11.8685 10.1684 12.6294 9.21572L9.07842 6.48917ZM10.9253 4.18054L9.85925 5.5125L13.4099 8.23827C14.0933 7.38225 14.5429 6.81845 14.5845 6.7647C14.7211 6.54304 14.7745 6.2297 14.7028 5.92804C14.6295 5.61887 14.437 5.35637 14.1595 5.18887C14.1003 5.14804 12.6961 4.05804 12.6528 4.02387C12.1245 3.60054 11.3536 3.67387 10.9253 4.18054Z"
                  fill="#575757"
                />
              </svg>
            </span> */}
          </div>
          {/* <button
            className="btn d-block unfollow-btn ml-auto"
            onClick={() =>
              appContext.updateModalType("deleteAccount", "Delete Account")
            }
          >
            Delete Account
          </button> */}
          <p className="profile-name mb-0 ml-3">
            {userData?.fName || ""} {userData?.lName || ""}
          </p>
          <p className="ml-3">
            {userData?.experiences
              ? truncateText(userData?.experiences, 60)
              : ""}{" "}
            {/* {concatenateAndTruncate(userData?.experties || [], 45, "value")}{" "} */}
            {/* <br />
            {userData?.address?.city || ""},{" "}
            {userData?.address?.stateName || ""},
            <br />
            {userData?.address?.countryName || ""} */}
          </p>
        </div>

        {/* <div className="row">
          <div className="col-md-3 ml-auto activity-btn">
            <NavLink
              to="/myspace"
              className="btn btn-primary rounded-pill activity-link"
            >
              My Space
            </NavLink>
          </div>
        </div> */}

        {/* <div className="tabbable boxed parentTabs">
          <ul className="nav nav-tabs justify-content-center border-bottom-0 mt-3">
            <li
              className={
                activeTab === profile
                  ? "active cursor-pointer"
                  : "cursor-pointer"
              }
            >
              <a
                onClick={(event) => tabSwitchHandler(event, profile)}
                className={`px-5 tab-pills my-space-active ${
                  activeTab === profile ? "tab-pill-active" : ""
                }`}
              >
                Profile
              </a>
            </li>
            <li
              className={
                activeTab === activity
                  ? "active cursor-pointer"
                  : "cursor-pointer"
              }
            >
              <a
                onClick={(event) => tabSwitchHandler(event, activity)}
                className={`px-5 mr-5 tab-pills my-space-active ${
                  activeTab === activity ? "tab-pill-active" : ""
                }`}
              >
                Activity
              </a>
            </li>
          </ul> */}

        {/* <div className="tab-content">
            {activeTab === profile && (
              <div
                className={`tab-pane fade ${
                  activeTab === profile ? "show active" : ""
                }`}
              >
                <div className="tabbable">
                  <ul className="nav nav-tabs">
                    <li className="active full-width">
                      <ProfileView type={"edit"} testData={testimonials} />
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {activeTab === activity && (
              <div
                className={`tab-pane fade mt-4 ${
                  activeTab === activity ? "show active" : ""
                }`}
              >
                <ProfileActivity />
              </div>
            )}
          </div> */}
        <ProfileActivity />
        {/* </div> */}
      </div>
    </>
  );
};

export default MyActivity;
